/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { AssetSelectionDto } from '../model/assetSelectionDto';
import { NewQuotDto } from '../model/newQuotDto';
import { QuotationDto } from '../model/quotationDto';
import { UsedAssetSelectionDto } from '../model/usedAssetSelectionDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AssetSelectionControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * alterAsset
     * 
     * @param brandId brandId
     * @param userCode userCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public alterAssetUsingGET(brandId: string, userCode: string, observe?: 'body', reportProgress?: boolean): Observable<AssetSelectionDto>;
    public alterAssetUsingGET(brandId: string, userCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AssetSelectionDto>>;
    public alterAssetUsingGET(brandId: string, userCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AssetSelectionDto>>;
    public alterAssetUsingGET(brandId: string, userCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (brandId === null || brandId === undefined) {
            throw new Error('Required parameter brandId was null or undefined when calling alterAssetUsingGET.');
        }

        if (userCode === null || userCode === undefined) {
            throw new Error('Required parameter userCode was null or undefined when calling alterAssetUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AssetSelectionDto>(`${this.basePath}/asset/alter/${encodeURIComponent(String(userCode))}/${encodeURIComponent(String(brandId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAssetDetails
     * 
     * @param userCode userCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAssetDetailsUsingGET(userCode: string, observe?: 'body', reportProgress?: boolean): Observable<AssetSelectionDto>;
    public getAssetDetailsUsingGET(userCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AssetSelectionDto>>;
    public getAssetDetailsUsingGET(userCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AssetSelectionDto>>;
    public getAssetDetailsUsingGET(userCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userCode === null || userCode === undefined) {
            throw new Error('Required parameter userCode was null or undefined when calling getAssetDetailsUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AssetSelectionDto>(`${this.basePath}/asset/details/new/${encodeURIComponent(String(userCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getUsedAssetDetails
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUsedAssetDetailsUsingGET(observe?: 'body', reportProgress?: boolean): Observable<UsedAssetSelectionDto>;
    public getUsedAssetDetailsUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UsedAssetSelectionDto>>;
    public getUsedAssetDetailsUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UsedAssetSelectionDto>>;
    public getUsedAssetDetailsUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UsedAssetSelectionDto>(`${this.basePath}/asset/details/used`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * saveNewQuot
     * 
     * @param newQuot newQuot
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveNewQuotUsingPOST(newQuot: NewQuotDto, observe?: 'body', reportProgress?: boolean): Observable<QuotationDto>;
    public saveNewQuotUsingPOST(newQuot: NewQuotDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QuotationDto>>;
    public saveNewQuotUsingPOST(newQuot: NewQuotDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QuotationDto>>;
    public saveNewQuotUsingPOST(newQuot: NewQuotDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (newQuot === null || newQuot === undefined) {
            throw new Error('Required parameter newQuot was null or undefined when calling saveNewQuotUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<QuotationDto>(`${this.basePath}/asset/newQuote`,
            newQuot,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateQuot
     * 
     * @param changedQuot changedQuot
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateQuotUsingPUT(changedQuot: NewQuotDto, observe?: 'body', reportProgress?: boolean): Observable<QuotationDto>;
    public updateQuotUsingPUT(changedQuot: NewQuotDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QuotationDto>>;
    public updateQuotUsingPUT(changedQuot: NewQuotDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QuotationDto>>;
    public updateQuotUsingPUT(changedQuot: NewQuotDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (changedQuot === null || changedQuot === undefined) {
            throw new Error('Required parameter changedQuot was null or undefined when calling updateQuotUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<QuotationDto>(`${this.basePath}/asset/changeQuote`,
            changedQuot,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
